/* eslint-disable no-param-reassign */
import sortAlphabetically from '../../../../utils/sortAlphabetically';

export const sortAlgoliaItemsAlphaNumerically = (items, facetType = null) => {
  if (facetType === 'variants.age_range') {
    const order = [
      'Preemie',
      '0-6m',
      '3m-18m',
      '3m-18m\n',
      '6-12m',
      '6-18m',
      '12-24m',
      '18m-3y',
      '18m-4yrs',
      '18m-4yrs\n',
      '2-3y',
      '2-4y',
      '3-5y',
      '3-7y',
      '3-10y',
      '4yrs+',
      '4-6y',
      '5-8y',
      '6-8y',
      '7-8y',
      '8y+',
      '8-12y',
      '12-16y',
      'Adult',
      'Adults',
      'All Ages',
      'No Age'
    ];

    const itemsObj = (() => {
      const obj = {};

      items.forEach((item) => {
        obj[item.label] = item;
      });

      return obj;
    })();

    const orderedList = [];

    order.forEach((orderedItem) => {
      if (itemsObj[orderedItem]) orderedList.push(itemsObj[orderedItem]);
    });

    return orderedList;
  }

  if (facetType === 'variants.shoe_sizes') {
    const getEUSize = (str) => {
      const EUsize = str.split('EU ')[1];
      return !EUsize.includes('W') ? +EUsize : (+EUsize.split('W')[0] + 0.5);
    };

    const orderedList = items.sort((a, b) => getEUSize(a.label) - getEUSize(b.label));

    return orderedList;
  }

  return items.sort((a, b) => sortAlphabetically(a.label, b.label));
};

export const sortShoes = (items) => sortAlgoliaItemsAlphaNumerically(items, 'variants.shoe_sizes');

export const sortAges = (items) => sortAlgoliaItemsAlphaNumerically(items, 'variants.age_range');

// TODO: comment back once clothing sizes are fixed
// export const sortClothingSizes = (items) =>
// sortAlgoliaItemsAlphaNumerically(items, 'variants.clothing_sizes');

export const cleanUpFacets = (isBrandRefined) => {
  const removeHiddenFacets = (items) => {
    const facets = [
      ...new Map(
        items
          .filter((item) => {
            const flags = item.attribute !== 'edits'
                && item.attribute !== 'trends_slug'
                && item.attribute !== 'trends'
                && (item.items || item.id === 'variants.maisonette_sale');
            return isBrandRefined ? item.attribute !== 'brand' && flags : flags;
          })
          .map((item) => [item.id, item])
      ).values()
    ];

    return facets;
  };

  return removeHiddenFacets;
};

export const getTotalActiveFilters = (items) => {
  const price = items.find((item) => item.id === 'variants.maisonette_sale');

  const totalActiveFilters = items
    .filter((item) => item.items)
    .reduce((sum, curr) => sum + curr.items.length, price ? 1 : 0);

  return {
    totalActiveFilters,
    price
  };
};

export const getActiveFilterCountFromFacets = (obj) => {
  let count = 0;

  for (const key in obj) {
    if (typeof obj[key] === "object") {
      count += getActiveFilterCountFromFacets(obj[key]); // Recursive call for nested objects
    } else {
      if (obj[key].includes("+")) {
        count += obj[key].split("+").length;
      } else {
        count++;
      }
    }
  }

  return count;
}

export const hasSelectedGender = (query, gender) => {
  const selectedGenders = query?.gender?.split('+');
  return query?.cats?.[0] === 'kids' && selectedGenders?.includes(gender);
};

export const refineOrRedirect = (item, facets, router, refine) => {
  const {cats, ...restFacets} = facets;
  const totalActiveFilters =  getActiveFilterCountFromFacets(restFacets);
  if (totalActiveFilters < 2) {
    router.push('/shop/outlet');
  } else {
    refine(item.value);
  }
};
